import { StateCreator } from 'zustand';

import { Product, ProductTenor } from '@protos/product';
import { User } from '@protos/user';
import ApiClient from '@services/ApiClient';

import { AppStore } from './AppStore';

export type CommonAppDataStore = {
  user: User | null;
  products: Product[] | null;
  tenors: ProductTenor[] | null;
  apiClient: ApiClient | null;
  adminApiClient: ApiClient | null | false;
  ready: boolean;
  setCommonData: (patch: Partial<Exclude<CommonAppDataStore, 'ready' | 'update'>>) => void;
};

export const makeCommonAppDataStore: StateCreator<AppStore, [], [], CommonAppDataStore> = (set, get) => {
  return {
    // Note: leaving the user settings (and hence dashboards and saved widget state) out of
    // the store for now, as it's a bit too heavy on
    user: null,

    products: null,

    tenors: null,

    ready: false,

    apiClient: null,

    adminApiClient: null,

    setCommonData: (patch: Partial<Exclude<CommonAppDataStore, 'ready' | 'update'>>) => {
      const toApply = { ...get(), ...patch };
      if (toApply.ready) {
        set(toApply);
      } else {
        if (toApply.user && toApply.products && toApply.tenors && toApply.apiClient && toApply.adminApiClient !== null) {
          console.log('store ready!', toApply);
          set({ ...toApply, ready: true });
        } else {
          set({ ...toApply });
        }
      }
    },
  };
};
